<auth-layout title="Verify Your Email ID" type="SIGNUP"
  [subTitile]="'Please enter the 4-digit verification code that was sent to ' + maskedEmail + '. The code is valid for 3 minutes.'">

  <form [formGroup]="otpForm" style="position: relative; max-width: 226px;">
    <div class="otp">
      <ng-otp-input
        formControlName="otp"
        (onInputChange)="onOtpChange($event)"
        [config]="{length:4}">
      </ng-otp-input>
      <div *ngIf="showSuccess" class="success-tick">
        ✅
      </div>
      <div *ngIf="loading" class="loader-overlay">
        <div class="spinner"></div>
      </div>
    </div>
    <div style="text-align: right;">
      <strong style="color: #c01e2f;">{{remainingTime}}</strong>
    </div>

    <div class="vca d-flex justify-content-between mt-3">
      <div>
        <span class="o-f" *ngIf="!loading" (click)="navigateToVerifyCustomer()">Verify</span>
      </div>
      <div class="forcenter" style="margin-top: 10px;">
        <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire; else notExpired"
          style="text-decoration: underline;">Resend OTP</a>
        <ng-template #notExpired>
          <a style="color: gray; cursor: no-drop; text-decoration: underline;">Resend OTP</a>
        </ng-template>
      </div>
    </div>
  </form>
</auth-layout>




<!-- <div class="content">
      <div class="o-c">
        <div>
          <div class="card">
            <p class="a-o-i">Enter verification code</p>
            <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{length:5}"></ng-otp-input>
            <span  class="o-t-p">
              <ng-container *ngIf="otp">
                Entered otp :-{{otp}}
              </ng-container>
              </span>
          </div>
        </div>
      </div>
    </div> -->